import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Version_Information extends Component {
    constructor(props) {
        super(props);

        if (this.props.receiver.active_controller.active_site != '' && this.props.receiver.active_controller.model == 'F10') {
            let site_info = window.app.state.site_list[this.props.receiver.active_controller.active_site];
            this.model_name = site_info.attr.name;
            this.model_number = 'DCP' + site_info.attr.model;
            this.system_version = site_info.attr.ver;
        } else {
            let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
            this.model_name = controller_info.name;
            if (!this.props.receiver.is_mobile) this.model_name = this.props.receiver.active_controller.web_controller_name;
            this.model_number = 'DCP' + controller_info.model;
            this.system_version = controller_info.version;
        }
    }

    handlePrevious = () => {
        window.app.content_area.current.switch_content.current.handleShowBottomMenu();
        this.props.content_handler('System');
    }

    render() {

        let style = {
            textAlign: 'center',
            width: '100%',
        }

        let main_content_style = {
            top: 0,
            width: '100%',
            height: this.props.height,
        }

        let textContainer = {
            margin: 20
        }

        let title = {
            fontWeight: 500,
            width: '50%',
            display: 'inline-block',
            textAlign: 'left'
        }

        let content = {
            width: '50%',
            display: 'inline-block',
            textAlign: 'right'
        }

        return (
            <div style={style}>
                <div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
                    <Top_Bar
                        width={this.props.width}
                        title={this.props.receiver.getString('version_information')}
                        left_button_type={'back'}
                        handleLeftButton={this.handlePrevious}
                    />

                    <div style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto' }}>

                        <div style={textContainer}>
                            <span style={title}>{this.props.receiver.getString("controller_name")}</span>
                            <span style={content}>{this.model_name}</span>
                        </div>

                        <div style={textContainer}>
                            <span style={title}>{this.props.receiver.getString("model_number")}</span>
                            <span style={content}>{this.model_number}</span>
                        </div>

                        <div style={textContainer}>
                            <span style={title}>{this.props.receiver.getString("app_version")}</span>
                            <span style={content}>{this.props.receiver.app_version}</span>
                        </div>

                        <div style={textContainer}>
                            <span style={title}>{this.props.receiver.getString("system_version")}</span>
                            <span style={content}>{this.system_version}</span>
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}